var exports = {
  "Qs": "x0a7806d5--ffc628--content",
  "cL": "x0a7806d5--ffc628--builder",
  "UU": "x0a7806d5--ffc628--name",
  "qr": "x0a7806d5--ffc628--footer",
};

module.exports = exports;
